import React from "react";
import { useI18n } from "@/context/I18nContext";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang, langs } = useI18n();
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="language-switcher">
      {langs.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}`}
          title={l.label}
          aria-label={l.label}
          className={`overflow-hidden rounded-sm border transition-all ${
            lang === l.code
              ? "border-blue-500 ring-2 ring-blue-500/40 opacity-100"
              : "border-slate-300 opacity-60 hover:opacity-100"
          }`}
        >
          <img
            src={`https://flagcdn.com/w40/${l.flag}.png`}
            srcSet={`https://flagcdn.com/w80/${l.flag}.png 2x`}
            alt={l.label}
            width={26}
            height={18}
            className="block h-[18px] w-[26px] object-cover"
          />
        </button>
      ))}
    </div>
  );
};
